import { useEffect } from 'react'
import loadDynamicYieldScript from 'helpers/loadDynamicYieldScript'

/**
 * Custom React hook to load the Dynamic Yield scripts when the component mounts.
 * Ensures the script is only loaded once and respects feature flags.
 */
export function useDynamicYieldScript() {
  useEffect(() => {
    loadDynamicYieldScript()
  }, [])
}
